export const Default = {
    data: function () {
        return {
            loading: false,
            status: '',
            message: ''
        }
    },
    methods: {
        getBlock: function (block) {
            return this.data.page.blocks.find(item => item.widgets === block);
        },
        getBlockItem: function (block) {
            return this.item.blocks.find(item => item.widgets === block);
        },
        getBlocks: function (block) {
            return this.data.page.blocks.filter(item => item.widgets === block);
        },
        getBlockStatus: function (block, label) {
            return this.getTranslation(this.getBlock(block), label, false)
        },
        getBlockTranslation: function (data, label) {
            return data.translations[this.locality][label] ? data.translations[this.locality][label] : '';
        },
        getTranslation: function (item, label, show = true) {
            return item.translations[this.data.settings.locality][label] ? item.translations[this.data.settings.locality][label] : show ? label : '';
        },
        getSnippetTranslation: function (item, label) {
            return item.translations[this.data.settings.locality].translation;
        },
        getContent: function (data, label) {
            return data.content[label] ? data.content[label] : '';
        },
        getSnippets: function (label) {
            let snippet =  this.data.snippets.find(item => item.content.code_label === label);
            return snippet !== undefined ? this.getSnippetTranslation(snippet, label) : label;
        },
        getHome: function (translatable, locality) {
            return translatable ?
                '/' + locality + '/' : '/';
        },
        getPath: function (data) {
            return '/' + data;
        },
        getSlug: function () {
            return this.data.slugs[this.data.settings.locality].slug;
        },
        getFeatured: function (data) {
            return this.data.featured[data];
        },
        setMessage: function (message, status) {
            this.flash(message, 'alert alert-' + status + ' notification');
        },
        setCookies: function (data) {
            this.$store.dispatch('setCookies', data);
        },
        setOverflow: function () {
            document.body.classList.remove('overflow-hidden');
        },
        setWindowTop: function () {
            window.scrollTo(0, 0);
        },
        setMeta: async function () {
            const author = document.head.querySelector("[name='author']");
            const description = document.head.querySelector("[name='description']");
            const keywords = document.head.querySelector("[name='keywords']");

            const ogUrl = document.head.querySelector("[property='og:url']");
            const ogTitle = document.head.querySelector("[property='og:title']");
            const ogDescription = document.head.querySelector("[property='og:description']");
            const ogImage = document.head.querySelector("[property='og:image']")

            const twitterCreator = document.head.querySelector("[name='twitter:creator']");
            const twitterSite = document.head.querySelector("[name='twitter:site']");
            const twitterTitle = document.head.querySelector("[name='twitter:title']");
            const twitterDescription = document.head.querySelector("[name='twitter:description']");
            const twitterImage = document.head.querySelector("[name='twitter:image']");

            this.meta.title = this.data.shareMeta.title;
            this.meta.author = this.data.shareMeta.author;
            this.meta.keywords = this.data.shareMeta.keywords;
            this.meta.description = this.data.shareMeta.description;
            this.meta.facebook_title = this.data.shareMeta.facebook_title;
            this.meta.facebook_description = this.data.shareMeta.facebook_description;
            this.meta.image = this.getPath(this.data.shareMeta.facebook_share_photo);

            author.setAttribute('content', this.data.shareMeta.author);
            description.setAttribute('content', this.data.shareMeta.description);
            keywords.setAttribute('content', this.data.shareMeta.keywords);

            ogTitle.setAttribute('content', this.data.shareMeta.facebook_title);
            ogDescription.setAttribute('content', this.data.shareMeta.facebook_description);
            ogImage.setAttribute('content', this.getPath(this.data.shareMeta.facebook_share_photo));
            ogUrl.setAttribute('content', window.location.href);

            twitterCreator.setAttribute('content', this.data.shareMeta.author);
            twitterTitle.setAttribute('content', this.data.shareMeta.facebook_title);
            twitterDescription.setAttribute('content', this.data.shareMeta.facebook_description);
            twitterImage.setAttribute('content', this.getPath(this.data.shareMeta.facebook_share_photo));
            twitterSite.setAttribute('content', window.location.href);
        },
        setLoading: function (data) {
            if (data) {
                this.$store.dispatch('setLoading', data);
            } else {
                setTimeout(() => {
                    this.$store.dispatch('setLoading', data)
                }, 1000);
            }
        },
        setModal: function () {
            $('.modal').modal('hide');
        },
        setPlaceholder: function (event) {
            event.target.src = '/app/images/static/placeholder.jpg';
        },
    }
};



// WEBPACK FOOTER //
// ./resources/assets/js/mixins/Default.js